import {cloneDeep, find, remove} from 'lodash';

const initialState = {
    errors: [],
    successes: [],
    fetched: false,
    fetching: false,
    mappingComplete: false,
    externalNetworks: [],
    networkId: null,
    networkName: null,
};

const actions = {
    NETWORK_SET_EXTERNAL_NETWORK_CHECKED: (state, {externalNetworkName, partnerId, checked}) => {
        const newState = cloneDeep(state);

        if (checked) {
            if (!find(newState.externalNetworks, {externalNetworkName, partnerId})) {
                newState.externalNetworks.push({externalNetworkName, partnerId});
            }
        } else {
            remove(
                newState.externalNetworks,
                (values) => values.externalNetworkName === externalNetworkName && values.partnerId === partnerId
            );
        }

        return newState;
    },

    NETWORK_SET_NETWORK: (state, {networkId, networkName}) => ({...state, networkId, networkName}),

    NETWORK_MAP_EXTERNAL_NETWORKS: (state, {fetching, mappingComplete}) => ({
        ...state,
        errors: [],
        fetching,
        mappingComplete,
    }),

    NETWORK_FETCH_FULFILLED: (state, {externalNetworkName}) => {
        const newState = cloneDeep(state);

        newState.successes.push({externalNetworkName});

        return newState;
    },

    NETWORK_FETCH_REJECTED: (state, {externalNetworkName, error}) => {
        const newState = cloneDeep(state);

        newState.errors.push({externalNetworkName, error});

        return newState;
    },

    NETWORK_FETCH_COMPLETED: (state, {fetching, mappingComplete}) => ({...state, fetching, mappingComplete}),

    NETWORK_MAPPING_RESET: () => initialState,
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
